// extracted by mini-css-extract-plugin
export default {"title":"add_pangolin_method_title__iiMc0","image":"add_pangolin_method_image__xuwNY","action":"add_pangolin_method_action__7DrKs"};